import { render, staticRenderFns } from "./NavbarV3.vue?vue&type=template&id=51b519a9"
import script from "./NavbarV3.vue?vue&type=script&lang=js"
export * from "./NavbarV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports